type Theme = 'light' | 'dark' | 'auto';


const React = window.React;
import { useState, useEffect, useRef } from 'react';

function ThemeSwitcher() {

    const refWrapper = useRef<HTMLDivElement>(null);
    const refList = useRef<HTMLUListElement>(null);
    const refButton = useRef<HTMLButtonElement>(null);
    const themeFromLocalStorage = localStorage.getItem('aw-theme') as Theme;

    const [theme, setTheme] = useState<Theme>(themeFromLocalStorage || 'auto');
    const [showThemeList, setShowThemeList] = useState(false);

    const themes = [{
        name: 'Light',
        value: 'light',
        Icon: LightIcon
    }, {
        name: 'Dark',
        value: 'dark',
        Icon: DarkIcon
    }, {
        name: 'Default',
        value: 'auto',
        Icon: AutoIcon
    }];

    useEffect(() => {

        localStorage.setItem('aw-theme', theme);
        if( 'function' === typeof window?.adw?.setTheme ){
            window.adw.setTheme(theme);
        }

    }, [theme]);

    // Register click away event to close the theme list
    useEffect(() => {

        const handleClickOutside = (event: MouseEvent) => {

            // If click is inside refWrapper, do nothing
            if ( refWrapper.current && refWrapper.current.contains(event.target as Node) ) {
                return;
            }

            if ( showThemeList == true ) {
                setShowThemeList(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showThemeList]);

    const hoverAnimation = (el: HTMLButtonElement | null, action: 'mouseEnter' | 'mouseLeave' | 'load' ) => {
        if( el && 'function' === typeof anime ){
            if( action === 'mouseEnter' ){
                anime({
                    targets: el,
                    scale: 1.2,
                    duration: 200,
                    easing: 'easeOutQuad',
                });
            }
            else if( action === 'mouseLeave' ){
                anime({
                    targets: el,
                    scale: 1,
                    duration: 200,
                    easing: 'easeOutQuad',
                });
            }
        }
    }

    return (
        <div ref={refWrapper} className="d-inline-flex flex-column justify-content-start  position-relative ">
            <button onClick={ () => setShowThemeList(!showThemeList) } className="btn btn-link text-decoration-none"
                style={{transformOrigin: 'center'}}
                ref={refButton}
                onMouseEnter={ () => hoverAnimation( refButton?.current, 'mouseEnter') }
                onMouseLeave={ () => hoverAnimation( refButton?.current, 'mouseLeave') }
            >
                {/* Show active theme Icon */}
                <span className={`mb-0`}>
                    {themes.find(item => item.value === theme)?.Icon()}
                </span>
            </button>
            <div className="position-absolute top-0 end-0 mt-5 z-3 ">
                
                {
                    showThemeList &&

                    <ul ref={refList}
                        {...(theme !== 'auto' ? { 'data-bs-theme': theme } : {})}
                        className="list-unstyled d-flex flex-column border rounded-4 top-0 mb-0 shadow-sm overflow-hidden"
                        style={{
                            color: 'var(--bs-body-color)',
                            background: 'var(--bs-body-bg)'
                        }}
                    >
                        {                
                            themes.map((item, i) => {

                            return (
                                <li key={item.value} className={`${item.value === theme ? '  ' : ' bg-light-subtle '}  ${i === themes.length - 1 ? '' : 'border-bottom'}`}>
                                    
                                    <button
                                        className={`btn btn-link d-flex align-items-center gap-3 px-4 text-decoration-none ${item.value === theme ? 'active text-primary ' : ''}`}
                                        
                                        onClick={() => setTheme(item.value)}
                                    >
                                        <span className={`d-inline-flex align-items-center h5 mb-0`}>
                                            <item.Icon />
                                        </span>
                                        {item.name}
                                    </button>
                                </li>
                            );
                        } )}

                    </ul>
                }
            
            </div>
        </div>
    );
}

export default ThemeSwitcher;

const AutoIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" className="bi bi-circle-half" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 0 8 1zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16"/>
    </svg>;
}
const LightIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" className="bi bi-sun" viewBox="0 0 16 16">
        <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/>
    </svg>;
}
const DarkIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" className="bi bi-moon-stars" viewBox="0 0 16 16">
        <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278M4.858 1.311A7.27 7.27 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.32 7.32 0 0 0 5.205-2.162q-.506.063-1.029.063c-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286"/>
        <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.73 1.73 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.73 1.73 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.73 1.73 0 0 0 1.097-1.097zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
    </svg>;
}